import { render, staticRenderFns } from "./FormConfigGenerator.vue?vue&type=template&id=2071e0d5&"
import script from "./FormConfigGenerator.vue?vue&type=script&lang=js&"
export * from "./FormConfigGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports